import { combineReducers } from 'redux';

import { GET_FOLLOW_UP_MODEL_REQUEST } from 'modules/followUp/actionTypes';
import loadingReducer from 'modules/global/reducers/generic.loading';
import genericSelectSlice, { createClearSelectReducer } from 'modules/global/reducers/generic.selectSlice';

import {
  FOLLOW_FILE,
  UNFOLLOW_FILE,
  IMPORT_TIRE_REPORT,
  DELAY_REMINDER_REQUEST,
  EVALUATE_INTERVENTION_TAGS,
  FETCH_INTERVENTIONS_SELECT_REQUEST,
  CLEAR_INTERVENTIONS_SELECT,
} from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import dashboard from './dashboard';
import details from './details';
import filters from './filters';
import finalInvoice from './finalInvoice';
import isRebranding from './isRebranding';
import kanban from './kanban';
import mediaries from './mediaries';
import mobility from './mobility';
import modals from './modals';
import reminders from './reminders';
import selectedInterventionId from './selectedInterventionId';
import workOrder from './workOrder';

/**
 * @typedef {{
 *  dashboard: SimpleSearchReducer,
 *  details: import('./details').InterventionsUIDetailsReducer,
 *  reminders: import('./reminders').InterventionsUIRemindersReducer,
 *  filters: import("./filters").InterventionFilterReducer,
 *  kanban: import('./kanban').KanbanInterventionReducer,
 *  modals: import('./modals').ModalsState,
 *  mobility: import('./mobility').MobilityReducer,
 *  workOrder : import('./workOrder').WorkOrderReducer,
 *  mediaries: import('./mediaries').MediariesReducer,
 *  isRebranding: boolean,
 *  finalInvoice: import('./finalInvoice').FinalInvoiceReducer,
 *  selectedInterventionId: string,
 *  selects: import('modules/global/reducers/generic.selectSlice').GenericSelectsReducer,
 *  loading: {
 *    follow: boolean,
 *    unfollow: boolean,
 *    followup: boolean,
 *    delay: boolean,
 *    evaluateTags: boolean,
 *    importTireReport: boolean,
 *  }
 * }} UIState
 */

export default combineReducers({
  dashboard,
  details,
  reminders,
  filters,
  kanban,
  modals,
  mobility,
  workOrder,
  mediaries,
  isRebranding,
  finalInvoice,
  selectedInterventionId,
  selects: genericSelectSlice(FETCH_INTERVENTIONS_SELECT_REQUEST, {
    reducers: {
      [LOCATION_CHANGE]: () => ({}),
      [CLEAR_INTERVENTIONS_SELECT]: createClearSelectReducer(),
    },
  }),
  loading: combineReducers({
    follow: loadingReducer(FOLLOW_FILE),
    unfollow: loadingReducer(UNFOLLOW_FILE),
    followup: loadingReducer(GET_FOLLOW_UP_MODEL_REQUEST),
    delay: loadingReducer(DELAY_REMINDER_REQUEST),
    importTireReport: loadingReducer(IMPORT_TIRE_REPORT),
    evaluateTags: loadingReducer(EVALUATE_INTERVENTION_TAGS),
  }),
});
